<div class="LoginBanner">
  <div
    *ngIf="IsOptimoney"
    class="LogoOuter LogoOuter d-flex align-items-center"
    [ngClass]="IsMobile ? 'justify-content-center' : 'justify-content-between'">
    <img src="../../assets/images/IFA/OptimumLogo.svg" alt="N/A" />
  </div>
  <div
    *ngIf="!IsOptimoney"
    class="LogoOuter d-flex align-items-center"
    [ngClass]="IsMobile ? 'justify-content-center' : 'justify-content-between'">
    <img alt="N/A" [src]="CompanyLogo" />
    <!-- <span [ngClass]='IsMobile && UserType==3  ? "d-block":"d-none"' class="InvLogin" routerLink="/login">MFD Login ></span>
    <span [ngClass]='IsMobile && UserType==2? "d-block":"d-none"' class="InvLogin" routerLink="/login/investor">Investor Login ></span> -->
  </div>
  <!-- <div class="MobileImageOuter">
    <img src="../../assets/images/IFA/LoginPage.jpg" class="w-100" alt="Login info mobile image"/>
</div> -->
</div>
